import { useState, useEffect } from "react";
import {
  Container,
  Divider,
  Grid,
  Typography,
  Stack,
  Button,
  Box,
  CircularProgress,
} from "@common-ui/ui";
import AddIcon from "@mui/icons-material/Add";

import DisplayPlaceForm from "./DisplayPlaceForm";
import CreatePlaceDialog from "./CreatePlaceDialog";

import { getOrgPlaces, addNewOrgPlace } from "../../../services/orgPlaces";
import { PlacesTreeView } from "../../Places/PlacesTreeView";

export const Places = ({ orgId, addresses, doesUserHavePermission }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [parent, setParent] = useState("");
  const [selectedPlaceId, setSelectedPlaceId] = useState("");
  const [mode, setMode] = useState("");
  const [refresh, setRefresh] = useState(false);

  const getPlaces = async () => {
    try {
      const response = await getOrgPlaces(orgId);
      if (response?.data?.length === 0) {
        setSelectedPlaceId("");
      } else {
        setSelectedPlaceId(response?.data[0].system_id);
        setMode("view");
      }
      setIsLoading(false);
      setRefresh(false);
    } catch (error) {
      alert(error);
      setRefresh(true);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    getPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (refresh) {
      setIsLoading(true);
      getPlaces();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  const handleAddNewPlace = (attributes) => {
    const addNewPlace = async () => {
      try {
        const response = await addNewOrgPlace(orgId, attributes);
        if (response === 200 || response === 204) {
          setSelectedPlaceId("");
          setRefresh(true);
        }
      } catch (error) {
        alert(error);
      }
    };
    addNewPlace();
  };

  const handleAddSubPlace = (parent) => {
    setMode("create");
    setParent(parent);
  };

  return (
    <>
      <Container maxWidth="md" component="main">
        <Grid item md={12} xs={12}>
          <Divider />
          <Stack direction="row" sx={{ maxWidth: { md: 800 } }}>
            <Grid item md={6} xs={12}>
              <Typography sx={{ my: 2 }} color="textPrimary" variant="h3">
                Organization Places
              </Typography>
            </Grid>
            <Grid item md={6} xs={12}>
              {doesUserHavePermission ? (
                <Button
                  type="primary"
                  variant="contained"
                  onClick={() => {
                    setMode("create");
                    setParent(null);
                  }}
                  sx={{ my: 3 }}
                >
                  <AddIcon />
                  Add Place
                </Button>
              ) : (
                ""
              )}
            </Grid>
          </Stack>
          {isLoading ? (
            <Box
              component="main"
              sx={{
                alignItems: "center",
                display: "flex",
                flexGrow: 1,
                minHeight: "100%",
              }}
            >
              <Container maxWidth="md" component="main">
                <Box sx={{ my: 3 }}>
                  <CircularProgress />
                </Box>
              </Container>
            </Box>
          ) : (
            <>
              {/* {mode === "" && (
                <Button
                  type="primary"
                  variant="contained"
                  onClick={() => {
                    setMode("create");
                  }}
                  sx={{ my: 3 }}
                >
                  <AddIcon />
                  Add Places
                </Button>
              )} */}
              {mode === "view" && (
                <Stack direction="row" sx={{ minHeight: 1066.61 }}>
                  <Grid container spacing={2}>
                    <Grid
                      // sx={{ borderRight: "1px solid #333" }}
                      item
                      md={4}
                      xs={12}
                    >
                      {/* <Typography variant="subtitle2">
                        Tree structure here
                      </Typography> */}
                      <PlacesTreeView
                        setSelectedPlaceId={setSelectedPlaceId}
                        handleAddSubPlace={(parentId) =>
                          handleAddSubPlace(parentId)
                        }
                        orgId={orgId}
                        refresh={refresh}
                        defaultSelectedPlaceId={selectedPlaceId}
                      />
                    </Grid>
                    {selectedPlaceId !== "" && (
                      <Grid
                        // sx={{ borderLeft: "1px solid #333" }}
                        item
                        md={8}
                        xs={12}
                      >
                        <DisplayPlaceForm
                          orgId={orgId}
                          handleAddSubPlace={handleAddSubPlace}
                          selectedPlaceId={selectedPlaceId}
                          setSelectedPlaceId={setSelectedPlaceId}
                          addresses={addresses}
                          setRefresh={setRefresh}
                          doesUserHavePermission={doesUserHavePermission}
                        />
                      </Grid>
                    )}
                  </Grid>
                </Stack>
              )}
              {mode === "create" && (
                <CreatePlaceDialog
                  parent={parent}
                  handleAddNewPlace={handleAddNewPlace}
                  setMode={setMode}
                  addresses={addresses}
                  //   handleAddSubPlace={handleAddSubPlace}
                />
              )}
            </>
          )}
        </Grid>
      </Container>
    </>
  );
};
